import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { withLang } from '../utils/routes';

const CorporateFooter = () => {
  const currentYear = new Date().getFullYear();
  const { currentLang } = useLanguage();
  const isEn = currentLang === 'en';
  const wl = (path: string) => withLang(path, currentLang);

  const serviceLinks = isEn
    ? [
        { label: 'AI Automations',  href: '/ai-consulting' },
        { label: 'SaaS Applications', href: '/ai-consulting' },
        { label: 'Consultation',    href: '/contact' },
        { label: '3D Printing',     href: '/3d-printing' },
      ]
    : [
        { label: 'AI-automationer',   href: '/ai-consulting' },
        { label: 'SaaS-applikationer', href: '/ai-consulting' },
        { label: 'Konsultation',       href: '/contact' },
        { label: '3D-printing',        href: '/3d-printing' },
      ];

  const productLinks = isEn
    ? [
        { label: 'Klagobot',              href: 'https://klagobot.se', external: true },
        { label: 'Swishkassa',            href: '/swishkassa' },
        { label: 'Solution examples',     href: '/exemple' },
        { label: 'Automations',           href: '/automations' },
      ]
    : [
        { label: 'Klagobot',              href: 'https://klagobot.se', external: true },
        { label: 'Swishkassa',            href: '/swishkassa' },
        { label: 'Exempel på lösningar',  href: '/exemple' },
        { label: 'Automationer',          href: '/automations' },
      ];

  return (
    <footer
      style={{
        background: '#0a0118',
        borderTop: '1px solid rgba(99,102,241,0.2)',
        boxShadow: 'inset 0 1px 0 rgba(99,102,241,0.1)',
      }}
    >
      <div className="container mx-auto px-6 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">

          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to={wl('/')} className="inline-flex items-center mb-4">
              <img
                src="/aifinity_logo_banner.png"
                alt="Aifinity"
                className="h-7 w-auto object-contain"
                style={{ filter: 'brightness(0) invert(1)' }}
              />
            </Link>
            <p className="text-sm text-slate-400 leading-relaxed max-w-[200px]">
              {isEn
                ? 'We build AI solutions and SaaS products for companies and associations.'
                : 'Vi bygger AI-lösningar och SaaS-produkter för svenska företag och föreningar.'}
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xs font-semibold tracking-widest uppercase text-slate-300 mb-4">
              {isEn ? 'Services' : 'Tjänster'}
            </h4>
            <ul className="space-y-2.5">
              {serviceLinks.map(({ label, href }) => (
                <li key={label}>
                  <Link to={wl(href)} className="text-sm text-slate-400 hover:text-indigo-400 transition-colors">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-xs font-semibold tracking-widest uppercase text-slate-300 mb-4">
              {isEn ? 'Products' : 'Produkter'}
            </h4>
            <ul className="space-y-2.5">
              {productLinks.map(({ label, href, external }) => (
                <li key={label}>
                  {external ? (
                    <a href={href} target="_blank" rel="noopener noreferrer" className="text-sm text-slate-400 hover:text-indigo-400 transition-colors">
                      {label}
                    </a>
                  ) : (
                    <Link to={wl(href)} className="text-sm text-slate-400 hover:text-indigo-400 transition-colors">
                      {label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-semibold tracking-widest uppercase text-slate-300 mb-4">
              {isEn ? 'Contact' : 'Kontakt'}
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to={wl('/contact')} className="text-sm text-slate-400 hover:text-indigo-400 transition-colors">
                  {isEn ? 'Contact us' : 'Kontakta oss'}
                </Link>
              </li>
              <li>
                <a href="mailto:info@aifinity.se" className="text-sm text-slate-400 hover:text-indigo-400 transition-colors">
                  info@aifinity.se
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/aifinity"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-slate-400 hover:text-indigo-400 transition-colors"
                >
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom bar */}
        <div
          className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-3"
          style={{ borderTop: '1px solid rgba(99,102,241,0.15)' }}
        >
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4">
            <p className="text-xs text-slate-500">
              © {currentYear} Aifinity AB · {isEn ? 'Built in Sweden' : 'Byggt i Sverige'}
            </p>
            <span className="hidden sm:inline text-slate-700">·</span>
            <p className="text-xs text-slate-600">Made with ♥ in Sweden</p>
          </div>
          <div className="flex items-center gap-4">
            <Link to={wl('/contact')} className="text-xs text-slate-500 hover:text-indigo-400 transition-colors">
              {isEn ? 'Privacy Policy' : 'Integritetspolicy'}
            </Link>
            <Link to={wl('/contact')} className="text-xs text-slate-500 hover:text-indigo-400 transition-colors">
              {isEn ? 'Terms' : 'Villkor'}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default CorporateFooter;
